"use client"

import { FormattedMessage } from "react-intl"

import {
  Button,
  TextButtonProps,
  useDownloadExperienceCalendarWeb,
} from "@bullseye/components"

// Note: this currently is only used on web (and not in the mobile app.)
// If you want to add it to mobile, add a new useDownloadExperienceCalendarMobile hook
// to handle it because the download needs to work differently.
export const AddToCalendarButton = ({
  variant = "primary",
  outlined = false,
  experienceSlug,
}: {
  variant?: TextButtonProps["variant"]
  outlined?: boolean
  experienceSlug: string
}) => {
  const { downloadCalendarWeb } =
    useDownloadExperienceCalendarWeb(experienceSlug)

  const handleAddToCalendar = () => {
    downloadCalendarWeb()
  }

  return (
    <Button
      as="button"
      startIconType="calendar"
      handlePress={handleAddToCalendar}
      variant={variant}
      outlined={outlined}
    >
      <FormattedMessage id="general.addToCalendar" />
    </Button>
  )
}
